(function (global) {
  "use strict";

  function fetchCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to load cart.");
      return response.json();
    });
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent("cart:open"));
  }

  function setButtonLabel(button, label) {
    var labelNode = button.querySelector("[data-add-label-text]");
    if (labelNode) {
      labelNode.textContent = label;
      return;
    }
    button.textContent = label;
  }

  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }],
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorBody) {
            throw new Error(errorBody.description || "Unable to add to cart.");
          });
        }
        return response.json();
      })
      .then(fetchCart)
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent("p4p:cart:updated", { detail: cart }),
        );
        openCartDrawer();
        return cart;
      });
  }

  function bindAddToCartButtons() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-add-to-cart]");
      if (!button || button.disabled) return;

      event.preventDefault();

      var variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      var defaultLabel =
        button.getAttribute("data-add-label") || "ADD TO CART 🛒";
      button.disabled = true;
      setButtonLabel(button, "ADDING…");

      addToCart(variantId, 1)
        .then(function () {
          setButtonLabel(button, defaultLabel);
        })
        .catch(function (error) {
          setButtonLabel(button, defaultLabel);
          window.alert(error.message || "Unable to add to cart.");
        })
        .finally(function () {
          setButtonLabel(button, defaultLabel);
          button.disabled = button.hasAttribute("data-sold-out");
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAddToCartButtons);
  } else {
    bindAddToCartButtons();
  }

  global.P4PCart = { addToCart: addToCart, fetchCart: fetchCart };
})(typeof window !== "undefined" ? window : this);
